import {createEntityAdapter, createSlice, EntityId} from '@reduxjs/toolkit';
import {mapValues} from 'lodash';
import {SchoolEntity} from '~/redux/schools/types';
import {RootState} from '~/redux/root-reducer';
import {ReducerState} from '~/utils/thunk-api/type';
import {addSchool, deleteSchool, fetchSchools, updateSchool} from '~/redux/schools/thunk';
import {
  addIdsToSources,
  createSelectAllBySource,
  deleteSuccess,
  fetchSuccess,
  upsertMany,
  upsertOneMutably,
} from '~/utils/thunk-api';
import {DEFAULT_SOURCE_REDUCER_STATE} from '~/utils/thunk-api/constants';
import {SOURCES_SCHOOL} from '~/redux/schools/entity-config';
import {getObjNthItem} from '~/utils/helpers';

interface InitialState extends ReducerState {}

const sources = mapValues(SOURCES_SCHOOL, () => DEFAULT_SOURCE_REDUCER_STATE);

const schoolsAdapter = createEntityAdapter<SchoolEntity>();

const initialState = schoolsAdapter.getInitialState<InitialState>({sources});

const schools = createSlice({
  name: 'schools',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchSchools.fulfilled, (state, {payload}) => {
      upsertMany(schoolsAdapter, state, payload.normalized.entities.schools);
      fetchSuccess(state, payload);
    });
    builder.addCase(addSchool.fulfilled, (state, {payload}) => {
      upsertMany(schoolsAdapter, state, payload.normalized.entities.schools);
      addIdsToSources(state, payload.normalized.result, [SOURCES_SCHOOL.SCHOOLS_DROPDOWN]);
    });
    builder.addCase(updateSchool.fulfilled, (state, {payload}) => {
      upsertOneMutably(schoolsAdapter, state, payload.normalized.entities.schools);
    });
    builder.addCase(deleteSchool.fulfilled, (state, {payload, meta}) => {
      const {arg} = meta;
      schoolsAdapter.removeOne(state, arg?.id as EntityId);
      deleteSuccess(state, arg?.id);
    });
  },
});

// export const {} = schools.actions;

export default schools.reducer;

export const {
  selectById: selectSchoolById,
  selectIds: selectSchoolsIds,
  selectEntities: selectSchoolsEntities,
  selectAll: selectAllSchools,
  selectTotal: selectTotalSchools,
} = schoolsAdapter.getSelectors((state: RootState) => state.schools);

export const [getSchoolsDropdown] = createSelectAllBySource('schools', selectSchoolsEntities, [
  SOURCES_SCHOOL.SCHOOLS_DROPDOWN,
]);
